import { Moment } from "moment";
import _ from "lodash";
import { format } from "lib/globalize-util";

export enum OrderStatus {
    PENDING = "none",
    SHIPPED = "all_shipped",
    PARTIAL = "partial",
    PARTIAL_BACKORDER = "partial::backorder",
    PARTIAL_CANCELLED = "partial::cancelled",
    PARTIAL_PENDING = "partial::pending",
    NOT_SHIPPED = "skip",
    NOT_SHIPPED_BACKORDER = "skip::backorder",
    NOT_SHIPPED_CANCELLED = "skip::cancelled",
}

export enum ShipmentStatus {
    PENDING = "pending",
    SHIPPED = "shipped",
    BACKORDER = "backorder",
    CANCELLED = "cancelled",
}

export enum ShipmentType {
    FULFILLED = "fulfilled",
    BACKORDER = "backorder",
    CANCELLED = "cancelled",
}

export interface IShipment {
    type: ShipmentType;
    shipment_info?: {
        status: string; // replace by union of types
        tracking_numbers: string[];
        type: string;
        shipment_date: Moment;
    };
    line_items: Array<{
        product: string;
        sizes: Array<{ size: string; quantity: number }>;
    }>;
}

export const LabelMap: { [key in ShipmentStatus]: string } = {
    [ShipmentStatus.PENDING]: "Pending",
    [ShipmentStatus.SHIPPED]: "Shipped",
    [ShipmentStatus.BACKORDER]: "Back Ordered",
    [ShipmentStatus.CANCELLED]: "Cancelled",
};

export const getOrderStatus = (list: OrderStatus[]): string => {
    if (_.includes(list, OrderStatus.PARTIAL)) {
        return format("Partially Shipped");
    } else if (_.includes(list, OrderStatus.NOT_SHIPPED)) {
        return format("Not Shipped");
    } else if (_.includes(list, OrderStatus.SHIPPED)) {
        return format("All Shipped");
    } else {
        return format("Pending");
    }
};

export const collectStatuses = (list: OrderStatus[]): string[] => {
    const statuses = [];

    if (_.includes(list, OrderStatus.PARTIAL)) {
        if (_.includes(list, OrderStatus.PARTIAL_BACKORDER)) {
            statuses.push(format("Partially Shipped - Backordered"));
        }
        if (_.includes(list, OrderStatus.PARTIAL_CANCELLED)) {
            statuses.push(format("Partially Shipped - Cancelled"));
        }
        if (_.includes(list, OrderStatus.PARTIAL_PENDING)) {
            statuses.push(format("Partially Shipped - Pending"));
        }
    } else if (_.includes(list, OrderStatus.NOT_SHIPPED)) {
        if (_.includes(list, OrderStatus.NOT_SHIPPED_BACKORDER)) {
            statuses.push(format("Not Shipped - Backordered"));
        }
        if (_.includes(list, OrderStatus.NOT_SHIPPED_CANCELLED)) {
            statuses.push(format("Not Shipped - Cancelled"));
        }
    } else {
        statuses.push(getOrderStatus(list));
    }

    return statuses;
};

export const getTrackerLink = (type: string, number: string) => {
    switch (type) {
        case "ups":
            return `http://wwwapps.ups.com/WebTracking/track?track=yes&trackNums=${number}`;
        case "fedex":
            return `https://www.fedex.com/fedextrack/?trknbr=${number}`;
        case "usps":
            return `https://tools.usps.com/go/TrackConfirmAction.action?tLabels=${number}`;
        case "dhl":
            return `http://www.dhl.com/content/g0/en/express/tracking.shtml?brand=DHL&AWB=${number}`;
        case "purolator":
            return `https://www.purolator.com/purolator/ship-track/tracking-details.page?pin=${number}`;
        default:
            return null;
    }
};

export const WORKING_ORDER_REFRESH_MESSAGE = "working-order-refresh";
export const SHIPMENTS_WITH_UNITS_OPTION = "__shipments_with_units";
